export default __webpack_public_path__ + "static/media/tb-icon.5fd38cf3.png";